export default __webpack_public_path__ + "static/media/safari-pinned-tab.964b0bb5.svg";